import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS
} from 'reducers/currentUser'

import Registry from 'registry';

export const LOCAL_STORAGE_KEY = 'authTokenData';

export default function authToken(state = {uid: null, token: null}, action) {
    if (action.type === LOGIN_SUCCESS) {
        return {
            uid: action.user.id,
            token: action.token
        };
    }

    if (action.type === LOGOUT_SUCCESS) {
        return {
            uid: null,
            token: null
        };
    }

    return state;
}

function useAuthTokenDisabled() {
    if (typeof window == 'undefined') return true;

    return !window.localStorage ||
           Registry.get('USE_AUTH_TOKEN', false) === false;
}

export function getFromPersistent() {
    if (useAuthTokenDisabled()) {
        return null;
    }

    let storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    let storedDataParsed;
    try {
        storedDataParsed = JSON.parse(storedData)
    } catch (e) {}

    if (typeof storedDataParsed === 'object') {
        return storedDataParsed;
    }

    return null;
}

export function saveToPersistent(data) {
    if (useAuthTokenDisabled()) {
        return false;
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
}


// WEBPACK FOOTER //
// ./src/reducers/authToken.js